import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import Modal from 'shared/components/common/Modal/Modal.component'
import { createDivAtom } from 'shared/atoms/factory'
import Button from 'shared/components/common/Button/Button.component'
import * as Actions from 'state/actions'

import styles from './ResetAllExportItemsModal.module.scss'

const Wrapper = createDivAtom(),
      Body = createDivAtom(),
      ButtonWrapper = createDivAtom()

const DeleteExportItemModal = (props) => {
  const { disabled } = props

  const [ isOpen, updateModal ] = useState(false)
  const toggleModal = () => updateModal(!isOpen)

  const dispatch = useDispatch()

  return (
    <>
      <Button
        className={styles.buttonBody}
        onClick={toggleModal}
        title='reset all'
        disabled={disabled}
      />

      <Modal
        isOpen={isOpen}
        onClose={toggleModal}
        size='medium'
      >
        <Wrapper className={styles.wrapper}>
          <Body className={styles.body}>
            Deleting is irreversible. Confirm that you want to permanently reset all.
          </Body>

          <ButtonWrapper className={styles.buttonWrapper}>
            <Button
              className={styles.buttonBody}
              onClick={() => {
                dispatch(Actions.resetExports())
                toggleModal()
              }}
              title='Reset'
            />
            <Button
              primary
              className={styles.buttonBody}
              onClick={toggleModal}
              title='Cancel'
            />
          </ButtonWrapper>
        </Wrapper>
      </Modal>
    </>
  )
}

DeleteExportItemModal.propTypes ={
  disabled: PropTypes.bool
}

export default DeleteExportItemModal